export default {
  title: '支持 Pet Care Note',
  subtitle: '您的每一份支持，都是我們持續優化產品的動力來源',
  oneTime: '單次贊助',
  monthly: '每月訂閱',
  oneTimeDescription: '一次性的鼓勵，為開發團隊注入能量，讓我們繼續為寵物主人打造更好的工具',
  monthlyDescription: '成為長期支持者，與 Pet Care Note 一起成長，見證每一次更新與進步',
  chooseAmount: '選擇支持金額',
  month: '/月',
  kittenSupport: '小貓守護者',
  puppySupport: '小狗守護者',
  bunnySupport: '兔兔守護者',
  securePayment: '透過 Stripe 安全加密付款',
  linkNotConfigured: '支付連結尚未設定，請聯繫開發團隊'
};